import $ from 'jquery';

function check_page_width()
{
	let page_width = $(window).innerWidth();

	if( page_width < 900 )
	{
		$('.index-archive').fadeIn(400);
		$('.list-archive').fadeIn(400);
	}
	else
	{
		if( $('.index-toggle').hasClass('active') )
		{
			console.log('index');
			$('.list-archive').fadeOut(400);
		}
		else
		{
			$('.index-archive').fadeOut(400);
		}
	}
}

export function archive_toggle()
{
	$('.archive-toggle').on('click', function()
	{
		if( $(this).hasClass('index-toggle') )
		{
			let current_display =  $('.index-archive').css('display');

			if( current_display != 'block' )
			{
				$('.index-archive').fadeIn(400);
				$('.list-archive').fadeOut(400);
			}
		}
		else
		{
			let current_display =  $('.list-archive').css('display');

			if( current_display != 'block' )
			{
				$('.list-archive').fadeIn(400);
				$('.index-archive').fadeOut(400);
			}
		}

		$(this).addClass('active').siblings().removeClass('active');

	})
}

export function archive_width()
{
	check_page_width();

	$(window).on('resize', function()
	{

		setTimeout(function()
		{
			check_page_width();
		}, 250 );

	} );

}

export function show_hide()
{
	$('.show-hide__trigger').on('click', function()
	{
		let wrapper = $(this).parent();
		let showhide_body = $(this).parent().find('.show-hide__body');

		if( wrapper.hasClass('active') )
		{
			wrapper.removeClass('active');
			wrapper.find('.icon').text('+');
			showhide_body.slideUp(400);
		}
		else
		{
			wrapper.addClass('active');
			wrapper.find('.icon').text('\u2012');
			showhide_body.slideDown(400);
		}
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/projects.js